<div class="ant-card-loading-content">
  <div class="ant-row" style="margin-left: -4px; margin-right: -4px;">
    <div class="ant-col-22" style="padding-left: 4px; padding-right: 4px;">
      <div class="ant-card-loading-block"></div>
    </div>
  </div>
  <div class="ant-row" style="margin-left: -4px; margin-right: -4px;">
    <div class="ant-col-8" style="padding-left: 4px; padding-right: 4px;">
      <div class="ant-card-loading-block"></div>
    </div>
    <div class="ant-col-15" style="padding-left: 4px; padding-right: 4px;">
      <div class="ant-card-loading-block"></div>
    </div>
  </div>
  <div class="ant-row" style="margin-left: -4px; margin-right: -4px;">
    <div class="ant-col-6" style="padding-left: 4px; padding-right: 4px;">
      <div class="ant-card-loading-block"></div>
    </div>
    <div class="ant-col-18" style="padding-left: 4px; padding-right: 4px;">
      <div class="ant-card-loading-block"></div>
    </div>
  </div>
  <div class="ant-row" style="margin-left: -4px; margin-right: -4px;">
    <div class="ant-col-13" style="padding-left: 4px; padding-right: 4px;">
      <div class="ant-card-loading-block"></div>
    </div>
    <div class="ant-col-9" style="padding-left: 4px; padding-right: 4px;">
      <div class="ant-card-loading-block"></div>
    </div>
  </div>
  <div class="ant-row" style="margin-left: -4px; margin-right: -4px;">
    <div class="ant-col-4" style="padding-left: 4px; padding-right: 4px;">
      <div class="ant-card-loading-block"></div>
    </div>
    <div class="ant-col-3" style="padding-left: 4px; padding-right: 4px;">
      <div class="ant-card-loading-block"></div>
    </div>
    <div class="ant-col-16" style="padding-left: 4px; padding-right: 4px;">
      <div class="ant-card-loading-block"></div>
    </div>
  </div>
  <div class="ant-row" style="margin-left: -4px; margin-right: -4px;">
    <div class="ant-col-8" style="padding-left: 4px; padding-right: 4px;">
      <div class="ant-card-loading-block"></div>
    </div>
    <div class="ant-col-6" style="padding-left: 4px; padding-right: 4px;">
      <div class="ant-card-loading-block"></div>
    </div>
    <div class="ant-col-8" style="padding-left: 4px; padding-right: 4px;">
      <div class="ant-card-loading-block"></div>
    </div>
  </div>
</div>